import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { CaseDetailService } from 'src/app/services/case-detail.service';
import { CustomerDetailsService } from 'src/app/services/customer-details.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { GoogleAnalyticsEventsService } from 'src/app/services/google-analytics-events.service';
import { ProactiveFeedbackComponent } from '../../shared/proactive-feedback/proactive-feedback.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { AddCaseDialogComponent } from 'src/app/components/dialogs/add-case-dialog/add-case-dialog.component';
import { CasesService } from 'src/app/services/cases.service';
import { CommonService } from 'src/app/services/common.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { TranslateService } from '@ngx-translate/core';
import { ProactiveAlertHistoryService } from 'src/app/services/proactive-alert-history.service';

@Component({
  selector: 'app-proactive-alerts-popup',
  templateUrl: './proactive-alerts-popup.component.html',
  styleUrls: ['./proactive-alerts-popup.component.scss']
})
export class ProactiveAlertsPopupComponent implements OnInit,AfterViewInit {
  response: any;
  isRequired = false;
  isRecomended = false;
  customerList = []
  customerID = null
  loader!: boolean;
  details: any;
  selectedPrinterFunc = []
  printerFunctioning = []
  functionStatus: boolean;
  selectedCustomerID = null
  selectedCustomerName = null
  selectedCustomerOpenCaseCount = 0
  toggleStyle: boolean = false;
  legendData = [{
   label: "PROACTIVE_ALERT_PAGE.PRO_ACTIVE_HSTORY.LABEL",
   placeholder: "PROACTIVE_ALERT_PAGE.PRO_ACTIVE_HSTORY.LABEL",
}]
legendsList = [
   { label: 'PROACTIVE_ALERT_PAGE.ACTIVITY_LIST.ALL', value: 'all',active:true},
   { label: 'Low ink level', value : 'Low ink level'},
   { label: 'System Error', value: 'System Error'},
   { label: 'Service Maintenance', value: 'Service Maintenance'},
   { label: 'User Maintenance', value: 'User Maintenance'},
   { label: 'Firmware Update', value: 'Firmware Update'},
   { label: 'Targeted Actions', value: 'Targeted Actions'}
]
    detail_set;
    filterValue = '';

  feedbackStatus: any;
  feedbackData: any;
  selectedAlertID = '';
  isSelected: any;
  solutionLoader: boolean;
  customerFilteredData: any;
    example_set = [
      { value: 'system_errors', title: 'System Errors'},
      { value: 'maintenances', title: 'Maintenances'},
      { value: 'firmware_updates', title: 'Firmware Updates'},
      { value: 'targeted_actions', title: 'Targeted Actions'}
  ];
  categorySet = {
     'System Errors': 'system_errors',
     'Maintenances': 'maintenances',
     'Firmware Updates': 'firmware_updates',
     'Targeted Actions': 'targeted_actions',
     'Low ink level': 'low_ink_level'
  }
  categorySetDetails = {
   'System Errors' : 'SystemErrors',
   'Maintenances': 'Maintenance',
   'Firmware Updates': 'FWupgrade',
   'Service Maintenance': 'ServiceMaintenance',
   'User Maintenance': 'UserMaintenance',
   'Targeted Actions': 'TargetedAction',
   'Low ink level': 'low_ink_level',
   'all': 'all'
  }
  printerID = ''
  currentCustomerID = ''
  customerIDCopy = ''
  hasNoLength = false
  lang = ''
  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router,private caseDetailSrv:CaseDetailService,
              public dialog: MatDialog,
              private customerDetailService: CustomerDetailsService,
              private dialogRef: MatDialogRef<ProactiveAlertsPopupComponent>,
              private googleAnalyticsEventsService: GoogleAnalyticsEventsService,
              private caseService: CasesService,
              private commonService: CommonService,
              private dashboardService: DashboardService,
              private liveannouncer: LiveAnnouncer,
              private translate: TranslateService,
              private proactiveAlertHistoryService : ProactiveAlertHistoryService
            ) { }

  ngOnInit(): void {
   this.lang = localStorage?.getItem('locale');
    this.response = this.data;
     if (this.response.customer?.callingFrom === 'Dashboard') {
      this.filterValue = this.response.customer.title;
      this.dashboardService.filterValue = this.response.customer.title;
        this.customerID = this.response.customer.customer_id
        this.selectedCustomerName = this.response.customer.customer_name
        this.customerIDCopy = this.customerID
        this.fromDashboard();
     } else {
     this.showFilterData();
    }
    if(!this.data.isCustomerDetail) {
      this.customerID = this.response?.customer?.customer_id;
      this.currentCustomerID = this.response?.customer?.customer_id;
      this.googleAnalyticsEventsService.emitEvent('reseller-portal', `Customer row clicked`, 'from dashboard proactive action dialog', null)
      if(this.customerID == null) {
        this.customerID = this.customerList[0]?.customer_id
      }
      this.getDetails(this.customerID);
      this.selectedCustomerID = this.customerID;
      this.selectedCustomerName = this.response?.customer?.customer_name;
      this.customerIDCopy = this.customerID
     //  this.loader = false;
    }
    
    }
    showFilterData() {
       if(!this.data.isCustomerDetail) {
      this.filterValue ="all";
      this.dashboardService.filterValue =this.filterValue;
     this.customerList = this.dashboardService.customerList;
       } else {
          this.dashboardService.filterValue = '';
          this.customerList = this.data.customer;
          this.selectedCustomerID = this.data.customer[this.data.index].deviceId;
          this.filterDataSet('', this.data.customer[this.data.index].actions)
       }
    }
   fromDashboard() {
      this.customerList = []
      let customerData = [];
      let arr = [];
      //this.customerID = this.response.customer.customer_id
      customerData = this.cloneObject(this.dashboardService.customerList);
      let filterValue = this.categorySet[this.filterValue]
      for (let i = 0; i < customerData.length; i++) {
         if (this.filterValue === 'Maintenances') {
            const { service_maintenances, user_maintenances } = customerData[i].actions['maintenances']
            customerData[i].alerts_count = service_maintenances.urgent_count + user_maintenances.urgent_count;
            customerData[i].alerts_count1 = service_maintenances.warning_count + user_maintenances.warning_count;
            customerData[i].low_ink_count =  service_maintenances.low_ink_count + user_maintenances.low_ink_count;
         } else if (this.filterValue === 'Service Maintenance') {
            const { service_maintenances, user_maintenances } = customerData[i].actions['maintenances']
            customerData[i].alerts_count = service_maintenances.urgent_count;
            customerData[i].alerts_count1 = service_maintenances.warning_count;
            customerData[i].low_ink_count =  service_maintenances.low_ink_count;
         } else if (this.filterValue === 'User Maintenance') {
            const { service_maintenances, user_maintenances } = customerData[i].actions['maintenances']
            customerData[i].alerts_count = user_maintenances.urgent_count;
            customerData[i].alerts_count1 = user_maintenances.warning_count;
            customerData[i].low_ink_count =  user_maintenances.low_ink_count;
         } else {
            if ((customerData[i].actions[filterValue]?.urgent_count > 0) || (customerData[i].actions[filterValue]?.warning_count > 0) || (customerData[i].actions[filterValue]?.low_ink_count > 0)) {
               const { urgent_count, warning_count, low_ink_count } = customerData[i]?.actions[filterValue];
               customerData[i].alerts_count = urgent_count;
               customerData[i].alerts_count1 = warning_count;
               customerData[i].low_ink_count = low_ink_count;
            } else {
               customerData[i].alerts_count = 0;
               customerData[i].alerts_count1 = 0;
               customerData[i].low_ink_count = 0;
            }
         }
         if(customerData[i].alerts_count != 0 || customerData[i].alerts_count1 != 0 || customerData[i].low_ink_count !=0 ) {
            arr.push(customerData[i]);
        }
      }
      this.customerList = this.sortArray1(arr);
      // if (this.customerList.length) {
            // this.customerID = this.customerList[0]?.customer_id
            // this.selectedCustomerID = this.customerID;
      // }
   }
   sortArray1(arr) {
    var arr1 = arr.filter(a => a.customer_type === 'vip')
    var arr2 = arr.filter(a => a.customer_type !== 'vip')
    var array1 = this.getSortedArr(arr1);
    var array2 = this.getSortedArr(arr2);
    return [...array1, ...array2]
  }
  getSortedArr(arr) {
    return arr.sort((a, b) => {
      return (b.alerts_count - a.alerts_count) || (b.alerts_count1 - a.alerts_count1)|| (b.tot_count - a.tot_count) ||  (moment(b.latest_timestamp).valueOf() - moment(a.latest_timestamp).valueOf()) 
    })
  }
   filterDataSet(filterValue, res) {
      if (filterValue === '') {
         var detail1 = [];
         var detail2 = [];
         this.detail_set = [];
         res.filter(val => {
            val.isShow = false;
            if (val.actionSeverity === 'Urgent') {
               detail1.push(val)
            } else {
               val.isShow = false;
               detail2.push(val)
            }
         })
         if (detail1.length) {
            this.isRequired = true;
            this.detail_set.push(
               {
                  deviceCategory: 'Requering immediate attention',
                  actions: this.sortArray(detail1)
               }
            )
         }
         if (detail2.length) {
            this.isRecomended = true;
            this.detail_set.push(
               {
                  deviceCategory: 'Recommended for next onsite visit',
                  actions: this.sortArray(detail2)
               }
            )
         }
      } else
      if (filterValue !== 'all') {
         this.detail_set = res.result.filter((x, i) => {
            x.actions = this.action_filter([...x.actions], filterValue);
            return (x.actions.length > 0)
         })
      } else {
         this.detail_set = res.result
      }

      // if no details, then show the first customer detail
      this.hasNoLength = false
      if(this.detail_set?.length == 0 && this.customerList.length > 0) { 
        this.hasNoLength = true
      //   if(res.result.length == 0) {
      //    this.loader = false;
      //    return
      //  }
       
       this.loader = false;
       this.onRowClick(this.customerList[0], 0)
      }


   }
   action_filter(arr, filterValue) {
   
      if (filterValue === "ServiceMaintenance" || filterValue === 'UserMaintenance') {
         var arrr = [];
         arr.filter(ele => {
            if (ele.ruleType === "Maintenance") {
               if (filterValue === 'UserMaintenance' && ele.userReplaceable) {
                  arrr.push(ele)
               } else if (filterValue === 'ServiceMaintenance' && !ele.userReplaceable) {
                  arrr.push(ele)
               }
            }
         })
         return arrr

      } else {
      return arr.filter(element => (element.ruleType === filterValue) || (element.ruleType == 'Low ink level' && filterValue === 'low_ink_level'));
      }
   }
  getDetails(customerID) {
    this.loader = true;
    this.selectedCustomerOpenCaseCount = 0;
    this.detail_set = [];
     this.dashboardService.getCustomers(customerID).subscribe(res => {
     let filterType = this.categorySetDetails[this.filterValue]
      this.filterDataSet(filterType,res);
         this.detail_set?.filter(x => {
            let requiredCount = 0;
            let recommendedCount = 0;
            let lowInkCount = 0
            if (x.actions) {
             x.actions = this.sortArray(x.actions)
               x.actions.forEach(v => {
                  v.isShow = false;
                  if (v.actionSeverity === "Warning") {
                     recommendedCount += 1;
                  } else if (v.actionSeverity === "Urgent") {
                      requiredCount += 1;
                  } else {
                    lowInkCount +=1
                  }
               })
            }
            x.recommendedCount = recommendedCount;
            x.requiredCount = requiredCount;
            x.low_level_ink = lowInkCount
         })
         var x = this.detail_set?.sort((a, b) => {
            return (b.requiredCount - a.requiredCount) || (b.recommendedCount - a.recommendedCount) || (b.lowInkCount - a.lowInkCount)
         })
         this.detail_set = x;
        this.loader = false;
     })
    let detailAPI = this.dashboardService.getAlertsDetails(customerID,false)
    let deviceStatusAPI =  this.customerDetailService.getCustomerDeviceStatus(customerID)
    let openCaseCountAPI =  this.dashboardService.getCustomerOpenCaseCount(customerID)
    forkJoin([detailAPI, deviceStatusAPI, openCaseCountAPI]).subscribe(response => {
      // this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'View action required for a customer in dashboard', `from dashboard | ${customerID}`, null)
      // this.details = response[0]?.result;
      //this.details = this.detail_set;
      this.printerFunctioning = [
        { value: "User Maintenance", active: false },
        {  value: "System Error", active: false },
        { value: "Targeted action", active: false }
      ]
      this.customerDetailService.storeDeviceStatus(response[1]?.result)
      // this.customerDetailService.storeDeviceStatus(response[1]?.result)
      this.selectedCustomerOpenCaseCount = response[2]?.result.cases_count
      // this.loader = false;
    })
  }

   sortArray(arr) {
      var arr1 = arr.filter(a => a.actionSeverity == 'Urgent')
      var arr2 = arr.filter(a => a.actionSeverity === 'Warning')
      var arr3 = arr.filter(a => a.actionSeverity === 'InkLevel')
      var array1 = this.sortActions(arr1);
      var array2 = this.sortActions(arr2);
      var array3 = this.sortActions(arr3);
      return [...array1, ...array2, ...array3]
   }
   sortActions(action) {
      return action.sort((a, b) => {
         return (moment(b.generateTs).valueOf() - moment(a.generateTs).valueOf())
      })
   }
   cloneObject(obj) {
      return JSON.parse(JSON.stringify(obj));
   }
flag = false;
  legendEvent(selected) {
     this.flag = true;
     let type = selected.toString()
     if (type === 'System Error') {
        this.filterValue = 'System Errors'
     } else if (type === 'Firmware Update') {
        this.filterValue = 'Firmware Updates'
     } else if (type === 'Targeted Actions') {
        this.filterValue = 'Targeted Actions'
     } else if(type === 'User Maintenance') {
      this.filterValue = "User Maintenance"
     }else if(type === 'Service Maintenance') {
      this.filterValue = "Service Maintenance"
     } else if(type == 'Low ink level') {
      this.filterValue = type
     } else {this.filterValue = "all"}
     this.customerID = this.customerIDCopy;
    if(type == 'all') {
       this.showFilterData();
      this.getDetails(this.customerID)
    } else {
       this.fromDashboard()
      this.getDetails(this.customerID)
   }



   if(type != 'all') {
      this.googleAnalyticsEventsService.emitEvent('reseller-portal', `${type} filter type clicked`, 'from dashboard proactive action dialog', null)
   }
  }

  accordianToggle(action, printer) {
   action.isShow = !action.isShow;
   if(action.actionSeverity == 'InkLevel') {
      return
   }

    if (!this.data?.isCustomerDetail) {
      this.printerID = printer?.device_id;
      if(action.isShow) { 
        this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'unfold action description', `from dashboard proactive action dialog | ${action?.actionUuid} | ${action?.eventName} | ${action?.eventCode} | ${printer.pn} | ${printer.sn}`, null)
      }
    } else {
      this.currentCustomerID = this.data?.customerID
      this.printerID  = this.data?.customer[this.data?.index]?.device_id;
      if(action.isShow) { 
         this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'unfold action description', `from cutomer detail proactive action dialog | ${action?.actionUuid}`, null)
       }
    }

   this.selectedAlertID = action.actionUuid;
   action.solutionURL = ''
   action.has500Err = false;
   action.has400Err = false;
   this.solutionLoader = true
   action.hideCloseAction = false;
   let soultionAPI = this.caseDetailSrv.getSolution(action?.actionUuid);
   let feedbackAPI =  this.caseDetailSrv.getFeedback(action?.actionUuid)
   this.getCaseID(action)
   feedbackAPI.subscribe(response => {
      this.feedbackStatus = response?.result?.feedback_found;
      this.feedbackData = response?.result?.feedback_options;
   })
   soultionAPI.subscribe(response => {
      action.solutionURL = response?.result?.solutionURL;
   }, err => {
      this.commonService.solutionError(action, err)
      this.solutionLoader = false
   })

}
   toggleArrow(action) {
      // if (this.selectedAlertID != action.actionUuid) {
      //   //this.actions?.printers[0]?.actions.map(ele => ele.show = false); // hide the toggle for all
      // }
      this.selectedAlertID = action.actionUuid;
      action.solutionURL = ''
      this.solutionLoader = true
      let soultionAPI = this.caseDetailSrv.getSolution(action?.actionUuid);
      let feedbackAPI = this.caseDetailSrv.getFeedback(action?.actionUuid)
      forkJoin([soultionAPI, feedbackAPI]).subscribe(response => {
         action.solutionURL = response[0]?.result?.solutionURL;
         this.feedbackStatus = response[1]?.result?.feedback_found;
         this.feedbackData = response[1]?.result?.feedback_options;
         this.getCaseID(action)
      }, err => {
         this.solutionLoader = false
      })
   }
 getCaseID(action) {
   action.caseID = ''
   this.caseDetailSrv.getCaseIDFromAction(action.actionUuid).subscribe(response => {
     action.caseID = response?.result?.hp_case_id;
     this.solutionLoader = false
   },
     (err => {
       this.solutionLoader = false
       if (err.status == 404) {
         action.caseID = null
       }
     }))
 }

getTitle() {
   const { callingFrom, label } = this.response.customer;
   return callingFrom === 'Dashboard' ? label : 'DASHBOARD.PRO_ALERTS';
}
  onRowClick(customer, index) {
     if(!this.data.isCustomerDetail) {
      this.currentCustomerID = customer?.customer_id;
    this.selectedCustomerID = customer?.customer_id;
    this.selectedCustomerName = customer?.customer_name;
    this.customerIDCopy = customer?.customer_id;
    this.googleAnalyticsEventsService.emitEvent('reseller-portal', `Customer row clicked`, 'from dashboard proactive action dialog', null)
    this.getDetails(customer?.customer_id);
     } else {
      this.selectedCustomerID = customer?.deviceId;
      this.selectedCustomerName = customer?.customer_name;
      this.filterDataSet('',customer.actions)
     }
  }

  getTimeStamp(updated_at) {
    return moment(updated_at).locale(this.lang).utc();
  }
  modifiedFormat(type, userReplaceable) {
   return this.dashboardService.modifiedEventType(type, userReplaceable)
 }
  navigateToPrinterDetail(printer) {
   if(!this.data.isCustomerDetail) {
      this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Go to printer detail page', `from dashboard proactive | ${printer?.pn} | ${printer?.sn}`, null)
   } else {
      this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Go to printer detail page', `from customer detail proactive | ${printer?.pn} | ${printer?.sn}`, null)
   }
    this.dialogRef.close();
    this.router.navigate([`/customers/printer/${printer.device_id}`])
  }

  navigateToCustomerDetail(customer_id) {
   // if(!this.data.isCustomerDetail) {
   //    this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Go to printer detail page', `from dashboard proactive | ${printer?.pn} | ${printer?.sn}`, null)
   // } else {
   //    this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Go to printer detail page', `from customer detail proactive | ${printer?.pn} | ${printer?.sn}`, null)
   // } 
    localStorage.setItem('open_case', 'true')
    this.dialogRef.close();
    this.router.navigate([`/customers/${customer_id}`])
  }
  getDeviceStatus(device) {
    return this.customerDetailService.getDeviceStatus(device)
  }

  getStatusColor(device) {
    return this.customerDetailService.getStatusColor(device)
  }
   closeAction(action) {
      this.confirmCloseAction(action)
   }
   viewCase(action) {
      if(!this.data.isCustomerDetail) {
         this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'view case clicked', `from dashboard proactive action dialog | ${action?.actionUuid}`, null)
      } else {
         this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'view case clicked', `from customer detail proactive action dialog | ${action?.actionUuid}`, null)
      }
      this.dialogRef.close();
      this.router.navigate([`/cases/${action.caseID}`])
    }
  
   confirmCloseAction(action) {
      let feedbackaction;
      let message;
      let btn1;
      let btn2;
      if (action.actionSeverity != 'InkLevel') {
        feedbackaction = 'FEEDBACK.ACTION'
        message = 'FEEDBACK.MESSAGE'
        btn1 = 'FEEDBACK.BUTTONS.NO'
        btn2 = 'FEEDBACK.BUTTONS.YES'
      } else {
        feedbackaction = 'FEEDBACK.ACTION'
        message = 'PROACTIVE_ALERT_PAGE.FEEDBACK.MESSAGE'
        btn1 = 'PROACTIVE_ALERT_PAGE.FEEDBACK.BUTTONS.NO'
        btn2 = 'PROACTIVE_ALERT_PAGE.FEEDBACK.BUTTONS.YES'
      }
      const ref = this.dialog.open(ConfirmModalComponent, {
        disableClose: false,
        data: {
          title: feedbackaction,
          body: message,
          buttons: { btn1: btn1, btn2: btn2, }
        },
        width: '500px',
        panelClass: 'confrim-dailog',
      })
  
      ref.afterClosed().subscribe(res => {
        if (res) {
          if (action.actionSeverity != 'InkLevel') {
            this.caseDetailSrv.closeAction(action?.actionUuid).subscribe(response => {
               this.dialogRef.close('reload');
            })
          } else {
            this.proactiveAlertHistoryService.createInkLevelHistory(action.ink_device_id).subscribe(response => {
               this.dialogRef.close('reload')
               this.dashboardService.isRefreshed = true           
             })
          }
        }
      })
    }
    
  
//     removeItemById(idToRemove) {
//     if(!this.data.isCustomerDetail) {
//       this.detail_set.forEach(detail => {
//           detail.actions = detail.actions.filter(action => action.ink_device_id !== idToRemove);
//       });
//       if(this.detail_set.length == 1) {
//          this.customerList = this.customerList.filter(ele => ele.customer_id != this.currentCustomerID)
//          this.dashboardService.storeCustomerList(this.customerList)
//          this.onRowClick(this.customerList[0], 0)
//       }
//     } else {
//       this.detail_set.forEach(detail => {
//          detail.actions = detail.actions.filter(action => action.ink_device_id !== idToRemove);
//      });
//      if(this.detail_set.length == 1) {
//       this.customerList = this.customerList.filter(ele => ele.customer_id != this.selectedCustomerID)
//       this.dashboardService.storeCustomerList(this.customerList)
//       this.onRowClick(this.customerList[0], 0)
//     }
//     }
//   }

   feedbackSelected(value, actionData) {
      if(!this.data.isCustomerDetail) {
         this.googleAnalyticsEventsService.emitEvent('reseller-portal', `feedback action clicked | ${value == 'true' ? 'Yes' : 'No'}`, `from dashboard proactive action dialog | ${value?.actionUuid}`, null)
      } else {
         this.googleAnalyticsEventsService.emitEvent('reseller-portal', `feedback action clicked | ${value == 'true' ? 'Yes' : 'No'}`, `from customer detail proactive action dialog | ${value?.actionUuid}`, null)
      }
      let dataPop;
      this.isSelected = value;
      if (this.isSelected == 'true') {
        dataPop = true;
      } else {
        dataPop = false;
      }
      let ref = this.dialog.open(ProactiveFeedbackComponent, {
        data: {
          popUpStatus: dataPop,
          feedbackOptions: this.feedbackData,
          alertInfo: actionData,
          caseId: this.customerID
        },
        width: '480px',
        position: { right: '20px', bottom: '25px' },
        hasBackdrop: true,
        disableClose: true
      })
      ref.afterClosed().subscribe(response=>{
        this.feedbackStatus = response.success
      })
    }

    createCase(value, printer) {
      if(!this.data.isCustomerDetail) { 
         this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Create case clicked', `from dashboard proactive action dialog | ${value?.actionUuid} | ${value?.eventName} | ${value?.eventCode} | ${printer.pn} | ${printer.sn}`, null)
      } else {
         this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Create case clicked', `from customer detail proactive action dialog | ${value?.actionUuid}`, null)
      }
      let ref = this.dialog.open(AddCaseDialogComponent, {
         data: {
           proactive: 'proactive',
           status: 'proactive',
           response: this.currentCustomerID || this.selectedCustomerID,
           response1: this.printerID,
           case_type: "001",
           value,
           alerts: {
             error_code: value?.error_code || value?.eventCode,
             event_name: value?.event_name || value?.eventName,
             time_stamp: value?.time_stamp || value?.generateTs,
             id: value?.id || value?.actionUuid
           }
         },
         disableClose: true
       })

       ref.afterClosed().subscribe(res => {
         if(res?.status == 'reload') {
           this.dialogRef.close()
           this.caseService.newCaseId = res.newCaseID
           this.router.navigate(['/cases'])
         }
       })
     }

     dropStatus(isOpened) {
      if(isOpened) {
         this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'filter clicked', `from dashboard proactive action dialog`, null)
      }
     }

     onClickSolutionURL(action, printer) {
      if(!this.data.isCustomerDetail) { 
         if(action.ruleType == 'SystemErrors') {
            this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'view troubleshooting links', `from dashboard proactive action dialog | ${action?.actionUuid} | ${action?.eventName} | ${action?.eventCode} | ${printer.pn} | ${printer.sn}`, null)
         } else {
            this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'view related documentation links', `from dashboard proactive action dialog  | ${action?.actionUuid} | ${action?.eventName} | ${action?.eventCode} | ${printer.pn} | ${printer.sn}`, null)
         }
      } else {
         if(action.ruleType == 'SystemErrors') {
            this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'view troubleshooting links', `from customer detail proactive action dialog | ${action?.actionUuid}`, null)
         } else {
            this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'view related documentation links', `from customer detail proactive action dialog  | ${action?.actionUuid}`, null)
         }
      }

     }

     public onSubTextClick(event: any): void {
      if (event.target.classList.contains('clickable')) {
        this.navigateToCustomerDetail(this.selectedCustomerID)
      }
    }

    ngAfterViewInit(): void {
      document.getElementById('close-btn').focus()

    }
}
